import { ApiContext } from "@api/api";
// import { LabelOutDTO } from "@api/ringil-api.v2"; // Original attempt, replace with actual type
import { EntityTypeEnum } from "@api/ringil-api.v2"; 
import { useEffect, useState, useContext } from "react";

// Ensure this LabelDefinition matches the one in CreateSupplierNotification & AttachmentComponent
// and the structure of the rich label objects on attachments.
interface LabelDefinition {
  labelId: string;
  labelValue: string; // Name of the label
  labelColor: string; // Color for the label
}

interface AttachmentLabelsBarProps {
  attachmentId: string; // Still useful as a key or for fetching if other props undefined
  resolvedLabels?: LabelDefinition[]; // This will contain the rich label objects for new attachments
  securityCode?: string; // Optional security code if needed for fetching
}

export const AttachmentLabelsBar: React.FC<AttachmentLabelsBarProps> = ({
  attachmentId,
  resolvedLabels,
  securityCode,
}) => {
  const { cuGetLabelsForEntity } = useContext(ApiContext);
  const [labelsToDisplay, setLabelsToDisplay] = useState<LabelDefinition[]>([]);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (resolvedLabels && resolvedLabels.length > 0) {
      setLabelsToDisplay(resolvedLabels);
    } else if (attachmentId) {
      cuGetLabelsForEntity(EntityTypeEnum.ATTACHMENTS, attachmentId, (fetchedLabels: any[]) => { 
        const transformedLabels = fetchedLabels.map(fl => ({
          labelId: fl.id || fl.labelId,
          labelValue: fl.name || fl.labelValue,
          labelColor: fl.colorHexCode || fl.color || fl.labelColor || '#cccccc', 
        }));
        setLabelsToDisplay(transformedLabels);
      },securityCode);
    } else {
      setLabelsToDisplay([]);
    }
  }, [attachmentId, resolvedLabels, cuGetLabelsForEntity]);

  if (labelsToDisplay.length === 0) {
    return null; 
  }

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: expanded ? 'wrap' : 'nowrap',
        cursor: 'pointer',
        marginTop: 4,
        minHeight: expanded ? 32 : 8,
        alignItems: 'center',
        gap: expanded ? 8 : 0,
      }}
      onClick={() => setExpanded(v => !v)}
      title={expanded ? 'Hide label names' : 'Show label names'}
    >
      {!expanded ? (
        <div
          style={{
            display: 'flex',
            overflow: 'hidden',
            borderRadius: 999,
            height: 8,
            minWidth: 40,
            maxWidth: 150,
            width: '100%',
            boxShadow: '0 1px 2px rgba(0,0,0,0.03)',
          }}
        >
          {labelsToDisplay.map((label, idx) => (
            <div
              key={label.labelId} // Use labelId from our LabelDefinition
              style={{
                backgroundColor: label.labelColor, // Use labelColor
                flex: 1,
                height: '100%',
                minWidth: 20,
              }}
            />
          ))}
        </div>
      ) : (
        labelsToDisplay.map(label => (
          <div
            key={label.labelId} // Use labelId
            className="px-2 py-1 rounded text-sm inline-flex"
            style={{
              backgroundColor: label.labelColor, // Use labelColor
              color: 'white',
              borderRadius: 8,
              marginRight: 4,
              marginBottom: 4,
              minWidth: 20,
            }}
          >
            {label.labelValue} {/* Use labelValue for the name */}
          </div>
        ))
      )}
    </div>
  );
};
